import { gql } from '@apollo/client'

const MANUAL_ADJUSTMENT = gql`
  mutation ManualAdjustment($manualAdjustment: ManualAdjustmentInput!) {
    manualAdjustment(manualAdjustment: $manualAdjustment) {
      message
      statusCode
      code
      error
    }
  }
`

export default MANUAL_ADJUSTMENT
